function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Teva_Logo",
  "data-name": "Teva Logo",
  d: "M2104,5763v16h11.966v24h124.7v-40Zm27.933,36.006H2119.94v-24.013h-11.96v-8h35.927v8h-11.973Zm37.9-24.013h-11.967V5779h11.967v8.007h-11.967v4h11.967v8h-33.927V5779H2147.9v-12.005h21.934Zm3.986,24.013v-32H2185.8v17.985h3.986v-17.985h20.127l-14.874,32Zm62.861,0H2224.7v-18h-3.987v18h-21.687l14.874-32.013h22.78Z",
  transform: "translate(-2104 -5763)",
  fill: "#050c1a",
  fillRule: "evenodd"
});

var SvgLogoTeva = function SvgLogoTeva(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 136.667,
    height: 40,
    viewBox: "0 0 136.667 40",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoTeva, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-teva.ee4370e9.svg";
export { ForwardRef as ReactComponent };